import Component from '@glimmer/component';

export default class TimeSeriesOutputHelpComponent extends Component {
  <template>
    <div class="c-help" ...attributes>
      <p class="c-help__primary">
        Download or plot your selected data below.
      </p>
      <ol class="c-ol">
        <li class="c-oli c-oli--1">Use the buttons to generate the output(s) of your choice.</li>
      </ol>
      {{yield}}
    </div>
  </template>
}
